module.exports = __webpack_public_path__ + "img/casual.5616afed.jpg";